import ErrorPage from "src/components/errors/ErrorPage";

export default function NotFoundPage() {
  return <ErrorPage errorMessage={"Stránka nebyla nalezena"} />;
}
